var excelTableGuardShiftLog;
var excelTableGuardShiftLogElement = 'guardshiftsearchgrid';

function CreateGuardShiftListGrid() {

    var widthForGrid = CalculateGridWidthSpace();

    var columns = [];
    var columnWidth = widthForGrid / 6;


    columns.push({ type: 'text', width: columnWidth, title: 'Start', name: 'Start' });
    columns.push({ type: 'text', width: columnWidth, title: 'End', name: 'End' });
    columns.push({ type: 'text', width: columnWidth, title: 'Duration (hours)', name: 'Duration' });
    columns.push({ type: 'text', width: columnWidth, title: 'Name', name: 'Name' });
    columns.push({ type: 'text', width: columnWidth, title: 'Number', name: 'Number' });
    columns.push({ type: 'text', width: columnWidth, title: 'Code', name: 'Code' });

 

    excelTableGuardShiftLog = jexcel(document.getElementById(excelTableGuardShiftLogElement), {
        data: null,
        columns: columns
    });
}

function RefreshGuardShiftListGrid(guardShiftData) {
    if (excelTableGuardShiftLog != null) {
        excelTableGuardShiftLog.setData(guardShiftData, false);
        return 1;
    } else {
        return 0;
    }
}

var shiftsDateRangePickerElementId = 'shiftsDateRangePicker';
var shiftsDateRangePickerStartSelected = '';
var shiftsDateRangePickerEndSelected = '';

function buildShiftsDateRangePickers() {
    $(document).ready(function () {
        $('#' + shiftsDateRangePickerElementId).daterangepicker(null, function (start, end, label) {
            shiftsDateRangePickerStartSelected = start.toISOString();
            shiftsDateRangePickerEndSelected = end.toISOString();

            console.log(shiftsDateRangePickerStartSelected);

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnChangeShiftsTimePeriodFromDateRange');
        });

    });
}

function getShiftsDateRangePickerStartSelected() {
    return shiftsDateRangePickerStartSelected;
}
function getShiftsDateRangePickerEndSelected() {
    return shiftsDateRangePickerEndSelected;
}


function CalculateWidthForTimeline() {

    
    var shiftTimelineBaseHolderWidth = $("#shiftTimelineBaseHolder").width();
    console.log("shiftTimelineBaseHolderWidth");
        console.log(shiftTimelineBaseHolderWidth);

    return shiftTimelineBaseHolderWidth;

   

    
   
   
}

function createShiftTimelineTooltip(el, text) {
    console.log("creating tooltip for");
    console.log("creating tooltip for eL : " + el);
    console.log($('#' + el));

    setTimeout(function () {
        tippy('#' + el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);
   
}